import { render, staticRenderFns } from "./ProposalsList.vue?vue&type=template&id=4642e05e&scoped=true"
import script from "./ProposalsList.vue?vue&type=script&lang=js"
export * from "./ProposalsList.vue?vue&type=script&lang=js"
import style0 from "./ProposalsList.vue?vue&type=style&index=0&id=4642e05e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4642e05e",
  null
  
)

export default component.exports